import React from 'react';
import { useSelector } from 'react-redux';
import { useBreakpoint } from '@panel/commons';
import { PreviewDesktop } from './previewDesktop';
import { PreviewMobile } from './previewMobile';
import { Step4Module3Selectors } from '../../../ducks/step4Module3';
import { PreviewSkeleton } from './previewSkeleton';

const Preview = React.memo(props => {
  const { postingPreview, contactInfo } = useSelector(Step4Module3Selectors.getPostingPreviewInfo);
  const [reachedBreakPoint] = useBreakpoint(700);
  const previewComponent = reachedBreakPoint ? PreviewDesktop : PreviewMobile;
  if (!postingPreview) {
    return <PreviewSkeleton />;
  }

  const previewData = {
    ...postingPreview,
    address: postingPreview.address.split(',')[0],
    prices: postingPreview.priceOperationTypeRequest[0].prices,
    description:
      postingPreview.description.length > 140 ? postingPreview.description.slice(0, 140) : postingPreview.description,
    features: postingPreview.features.reduce((obj, feature) => {
      if (feature.value && feature.value !== '0') {
        obj[feature.feature_id] = feature;
      }
      return obj;
    }, {})
  };
  const contactData = {
    ...contactInfo,
    phone: contactInfo.phone.reduce((phones, p) => {
      phones[p.phone_type] = p;
      return phones;
    }, {})
  };
  return React.createElement(previewComponent, { ...props, postingPreview: previewData, contactInfo: contactData });
});

export { Preview };
